const selectionQueryCreator = (type) => {
  return `query ${type}ByIds($ids:[UUID!]!){
  ${type}ByIds(ids:$ids){    
      id
      displayName
    }
  }`
}
export default selectionQueryCreator;